var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8398 4.02341L16.3992 12.6667H7.01894C6.62497 12.6667 6.29096 12.377 6.23523 11.9869L5.03174 3.5625H17.4493C17.6939 3.5625 17.88 3.78214 17.8398 4.02341ZM10.3958 7.91667V5.54167H11.9791V7.91667H13.9583L11.1874 11.0833L8.41659 7.91667H10.3958Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0835 3.16666H3.37605L4.66809 12.2109C4.83525 13.3809 5.8373 14.25 7.01922 14.25H17.1252V12.6667H7.01922C6.62525 12.6667 6.2912 12.377 6.23551 11.9869L4.89494 2.60289C4.81134 2.01787 4.31032 1.58333 3.71936 1.58333H2.0835V3.16666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3957 7.91667V5.54167H11.979V7.91667H13.9582L11.1873 11.0833L8.4165 7.91667H10.3957Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.021 16.2292C8.021 16.885 7.48935 17.4167 6.8335 17.4167C6.17764 17.4167 5.646 16.885 5.646 16.2292C5.646 15.5733 6.17764 15.0417 6.8335 15.0417C7.48935 15.0417 8.021 15.5733 8.021 16.2292Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5415 17.4167C16.1974 17.4167 16.729 16.885 16.729 16.2292C16.729 15.5733 16.1974 15.0417 15.5415 15.0417C14.8856 15.0417 14.354 15.5733 14.354 16.2292C14.354 16.885 14.8856 17.4167 15.5415 17.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.5f03d9bd332f3b84cd4de2d96d4f817a.svg";
export { ForwardRef as ReactComponent };